<!-- Shared Confirmation Modal Component -->
<!-- Centralized confirmation modal for use across multiple modules -->

<div>
  <div class="div-message-box" [ngClass]="getAnimationClasses()">
    <div class="message-box-container" [ngClass]="getAnimationClasses()">
      <div class="message-box-middle">
        <!-- Loading Spinner Section -->
        @if (shouldShowLoadingSpinner()) {
<div class="loading-section">
          <i [ngClass]="getLoadingSpinnerClasses()"></i>
          <span class="loading-text">{{ config.loadingText }}</span>
        </div>
}
        
        <!-- Main Content Section -->
        @if (!config.loading) {
<div>
          <span class="msg-title ng-binding">
            <i [ngClass]="getIconClasses()"></i>{{ config.title }}
          </span>
          
          <p class="p-text ng-binding">{{ config.message }}</p>
          
          <div class="message-box-button-section">
            @if (config.showConfirmButton) {
<button 
             
              [ngClass]="getButtonClasses(config.confirmButtonClass, 'confirm')"
              id="switch-yes" 
              (click)="onConfirm()"
              [disabled]="config.loading">
              {{ config.confirmButtonText }}
            </button>
}
            
            @if (config.showCancelButton) {
<button 
             
              [ngClass]="getButtonClasses(config.cancelButtonClass, 'cancel')"
              id="switch-no" 
              (click)="onCancel()"
              [disabled]="config.loading">
              {{ config.cancelButtonText }}
            </button>
}
          </div>
        </div>
}
      </div>
    </div>
  </div>
</div>